import { objectSchemaOf, Joi } from '../helpers';

export interface IStaff {
  staffId: string;
  organisationId: string;
  firstName: string;
  lastName: string;
  email: string;
  primaryPhone?: string;
  position?: string;
  isAdministrator: boolean;
  avatar?: string;
  slackChannelId?: string;
  createdOn: number;
  lastUpdatedOn: number;
  hasLeft?: boolean;
  isRemote?: boolean;
  nicknames?: string[];
  companyId?: string;
  companyName?: string;
  isCompanyAdministrator?: boolean;
}

export const staffSchema = objectSchemaOf<IStaff>({
  staffId: Joi.string().required(),
  organisationId: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  email: Joi.string().required(),
  primaryPhone: Joi.string().optional(),
  position: Joi.string().optional(),
  isAdministrator: Joi.boolean().required(),
  avatar: Joi.string().optional(),
  slackChannelId: Joi.string().optional(),
  createdOn: Joi.number().required(),
  lastUpdatedOn: Joi.number().required(),
  hasLeft: Joi.boolean().optional(),
  isRemote: Joi.boolean().optional(),
  nicknames: Joi.array()
    .items(Joi.string())
    .optional(),
  companyId: Joi.string().optional(),
  companyName: Joi.string().optional(),
  isCompanyAdministrator: Joi.boolean().optional(),
});
